import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import Card from "../models/common/Card";


function ContentBlock(props) {

    const [eyeBrownHeader] = useState(props.eyeBrownHeader);
    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [image] = useState(props.image);
    const [imageIsOnLeftSide] = useState(props.imageIsOnLeftSide);
    const [mainClass] = useState(props.mainClass);
    const [sectionWidth] = useState(props.sectionWidth);

    const [frameTitle] = useState(props.frameTitle);
    const [sectionOneTitle] = useState(props.sectionOneTitle);
    const [sectionOneText] = useState(props.sectionOneText);
    const [sectionTwoTitle] = useState(props.sectionTwoTitle);
    const [sectionTwoText] = useState(props.sectionTwoText);
    const [sectionThreeTitle] = useState(props.sectionThreeTitle);
    const [sectionThreeText] = useState(props.sectionThreeText);

    const [buttonLink] = useState(props.buttonLink);

    return (

        <div className={mainClass}>
            {title ? <div className="row headerGeneral ">
                <div className="headerGeneralContent headerLetter">
                    <div className="eyebrowHeader">
                        {eyeBrownHeader}
                    </div>
                    <div className="headerOne">
                        {title}
                    </div>
                    <div className="headerTwo">
                        {subTitle}
                    </div>
                </div>
            </div> : ""}
            <div className={"sectionLayout " + sectionWidth}>
                <div className="sectionFrame mb-5">
                    {imageIsOnLeftSide ? <div className="sectionImage mr-5">
                        <img src={image} className='img-fluid shadow-4 ' alt='...' />
                    </div> : ""}
                    <div className="sectionCopy">
                        <div className="sectionTitles">
                            <div className="sectionHeader sectionHeaderText">
                                {frameTitle}
                            </div>
                            <div className={"sectionSubCopy " + (sectionOneTitle ? "mt-4" : "")}>
                                <div className="sectionSubCopyText">
                                    {sectionOneTitle ? <div className="sectionSubCopyBold">{sectionOneTitle}</div>  : ""}
                                    {sectionOneText}
                                    {sectionTwoTitle ? <div className="sectionSubCopyBold mt-3">{sectionTwoTitle}</div> : ""}
                                    {sectionTwoText}
                                    {sectionThreeTitle ? <div className="sectionSubCopyBold mt-3">{sectionThreeTitle}</div> : ""}
                                    {sectionThreeText}
                                    {buttonLink ? <div className="buttonDiv mt-4">
                                        <a href={buttonLink} target="_blank" className="wid98 d-flex justify-content-center"  >
                                            <div className="buttonSignUp pad5-4 buttonHover">
                                                <div className="buttonLetters">Start Learning</div>
                                            </div>
                                        </a>
                                    </div> : ""}
                                </div>
                            </div>

                        </div>
                    </div>
                    {imageIsOnLeftSide ? "" : <div className="sectionImage ml-5">
                        <img src={image} className='img-fluid shadow-4 ' alt='...' />
                    </div> }
                </div>
            </div>
        </div>

    )


}

export default withRouter(ContentBlock);



